var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagtam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagtam",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.723,
    height: 26.723,
    viewBox: "0 0 26.723 26.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10468",
    "data-name": "Group 10468",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29543",
    "data-name": "Path 29543",
    d: "M13.361,2.407c3.568,0,3.99.014,5.4.078a7.392,7.392,0,0,1,2.481.46,4.139,4.139,0,0,1,1.536,1,4.139,4.139,0,0,1,1,1.536,7.392,7.392,0,0,1,.46,2.481c.064,1.409.078,1.832.078,5.4s-.014,3.99-.078,5.4a7.392,7.392,0,0,1-.46,2.481,4.425,4.425,0,0,1-2.536,2.536,7.392,7.392,0,0,1-2.481.46c-1.409.064-1.831.078-5.4.078s-3.99-.014-5.4-.078a7.392,7.392,0,0,1-2.481-.46,4.139,4.139,0,0,1-1.536-1,4.14,4.14,0,0,1-1-1.536,7.392,7.392,0,0,1-.46-2.481c-.064-1.409-.078-1.832-.078-5.4s.014-3.99.078-5.4a7.392,7.392,0,0,1,.46-2.481,4.139,4.139,0,0,1,1-1.536,4.139,4.139,0,0,1,1.536-1,7.392,7.392,0,0,1,2.481-.46c1.409-.064,1.832-.078,5.4-.078m0-2.407C9.733,0,9.278.015,7.853.08A9.806,9.806,0,0,0,4.609.7,6.549,6.549,0,0,0,2.243,2.243,6.549,6.549,0,0,0,.7,4.609,9.806,9.806,0,0,0,.08,7.853C.015,9.278,0,9.733,0,13.361s.015,4.084.08,5.509A9.806,9.806,0,0,0,.7,22.114,6.549,6.549,0,0,0,2.243,24.48a6.55,6.55,0,0,0,2.367,1.541,9.807,9.807,0,0,0,3.243.621c1.425.065,1.88.08,5.509.08s4.084-.015,5.509-.08a9.807,9.807,0,0,0,3.243-.621,6.832,6.832,0,0,0,3.908-3.908,9.807,9.807,0,0,0,.621-3.243c.065-1.425.08-1.88.08-5.509s-.015-4.084-.08-5.509a9.807,9.807,0,0,0-.621-3.243A6.55,6.55,0,0,0,24.48,2.243,6.549,6.549,0,0,0,22.114.7,9.806,9.806,0,0,0,18.87.08C17.445.015,16.99,0,13.361,0Z",
    transform: "translate(0 0)",
    fill: "#ffe800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29544",
    "data-name": "Path 29544",
    d: "M129.417,122.556a6.861,6.861,0,1,0,6.861,6.861A6.861,6.861,0,0,0,129.417,122.556Zm0,11.315a4.454,4.454,0,1,1,4.454-4.454A4.454,4.454,0,0,1,129.417,133.871Z",
    transform: "translate(-116.056 -116.056)",
    fill: "#ffe800"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.603,
    cy: 1.603,
    r: 1.603,
    transform: "translate(18.89 4.626)",
    fill: "#ffe800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagtam);
export default __webpack_public_path__ + "static/media/instagtam.1c282359653ccf707f387b02285b66a2.svg";
export { ForwardRef as ReactComponent };